import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react';
import { cn } from '../../lib/cn';

export function HugeIcon({
  className,
  icon,
  size = 24,
  strokeWidth = 1.7,
}: {
  className?: string;
  icon: IconSvgElement;
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <HugeiconsIcon
      className={cn('shrink-0', className)}
      color="currentColor"
      icon={icon}
      size={size}
      strokeWidth={strokeWidth}
    />
  );
}
